import React from 'react';

import { 
  Redirect 
} from 'react-router-dom';
import { getCookie } from 'src/utils/utils';

interface MockGuardProps {
  children:any
}


const MockGuard: React.FC<MockGuardProps> = ({ children })  => {
  const isMock = getCookie("useMock")
  
  if (isMock !== "true")  return <Redirect to="/404" />;
  
  return children;
}


export default MockGuard;
